export default __webpack_public_path__ + "static/media/Sportz News.73c64575.png";